import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <section className="not-found-section">
      <div className="not-found-card">
        <span className="not-found-emoji" role="img" aria-label="Sad face">😢</span>
        <h1>404</h1>
        <h2 className="not-found-subheading">Lost in the Void</h2>
        <p>
          Oops! The page you're looking for doesn't exist.
        </p>
        <Link to="/" className="not-found-home-link">Take me home</Link>
      </div>
    </section>
  );
} 